export function fetchOpenPaymentNonce(tokenUrl, gatewayApi, requestBody) {
    return fetch(tokenUrl, {
        method: 'POST',
        headers: {
            Authorization: 'Basic ' + btoa(gatewayApi + ':'),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
    })
        .then((response) => response.json())
        .then((data) => {
            if (data.nonce_token === undefined) {
                return {
                    ok: false,
                    error: data.error_message || 'Card error',
                };
            }
            return {
                ok: true,
                nonce: data.nonce_token,
            };
        })
        .catch(function (err) {
            console.error('Failed to tokenize card via', tokenUrl, err);
            return {
                ok: false,
                error: 'Could not tokenize card.',
            };
        });
}
